/* eslint-disable max-len */
// example : <OrderOnCallButton onClick={somefunction} type={insert-type-here} text="hello" />
// type 1 green button, type 2 cancel button, default white button
import React from 'react';
import PropTypes from 'prop-types';
import OrderOnCallButton from './OrderOnCallButton';

require('./FooterButtons.scss');

const FooterButton = ({
  proceedBtnClick,
  proceedBtnText,
  showDiagBtn,
  showDiagBtnEnabled,
  diagBtnText,
  diagBtnClick,
  backBtnClick,
  backBtnText,
  cancelBtnClick,
  cancelBtnText,
  loading,
  nextStateAllowed,
  showServiceBtn,
  serviceButtonTxt,
  serviceBtnClick,
  showServicesDropup,
  servicesDropupContent,
}) => (
  <div className="footerButtonContainer">
    {backBtnText !== '' &&
      <div className="buttonContainer"><OrderOnCallButton text={backBtnText} onClickFunction={backBtnClick} /></div>}
    {proceedBtnText !== '' &&
      <div className="buttonContainer"><OrderOnCallButton disabled={!nextStateAllowed || loading} type={1} text={loading ? 'Loading...' : proceedBtnText} onClickFunction={proceedBtnClick} /></div>}
    {showDiagBtn && diagBtnText !== '' &&
      <div className="buttonContainer"><OrderOnCallButton disabled={loading || !nextStateAllowed || !showDiagBtnEnabled} type={1} text={loading ? 'Loading...' : diagBtnText} onClickFunction={diagBtnClick} /></div>}
    {showServiceBtn && serviceButtonTxt !== '' &&
      <div className="buttonContainer">
        {showServicesDropup && servicesDropupContent}
        <OrderOnCallButton disabled={loading || !nextStateAllowed} type={3} text={loading ? 'Loading...' : serviceButtonTxt} onClickFunction={serviceBtnClick} />
      </div>}
    {cancelBtnText !== '' &&
      <div className="buttonContainer"><OrderOnCallButton type={2} text={cancelBtnText} onClickFunction={cancelBtnClick} /></div>}
  </div>
);

FooterButton.propTypes = {
  proceedBtnClick: PropTypes.func,
  proceedBtnText: PropTypes.string,
  diagBtnText: PropTypes.string,
  diagBtnClick: PropTypes.func,
  backBtnClick: PropTypes.func,
  backBtnText: PropTypes.string,
  cancelBtnClick: PropTypes.func,
  cancelBtnText: PropTypes.string,
  loading: PropTypes.bool,
  showDiagBtn: PropTypes.bool,
  showDiagBtnEnabled: PropTypes.bool,
  nextStateAllowed: PropTypes.bool,
  showServiceBtn: PropTypes.bool,
  serviceButtonTxt: PropTypes.string,
  serviceBtnClick: PropTypes.func,
  showServicesDropup: PropTypes.bool,
  servicesDropupContent: PropTypes.node,
};

FooterButton.defaultProps = {
  proceedBtnClick: undefined,
  proceedBtnText: '',
  diagBtnText: '',
  diagBtnClick: undefined,
  backBtnClick: undefined,
  backBtnText: '',
  cancelBtnClick: undefined,
  cancelBtnText: '',
  loading: false,
  showDiagBtn: false,
  showDiagBtnEnabled: false,
  nextStateAllowed: true,
  showServiceBtn: false,
  serviceButtonTxt: '',
  serviceBtnClick: undefined,
  showServicesDropup: false,
  servicesDropupContent: null,
};

export default FooterButton;
